export default "__VITE_PUBLIC_ASSET__33c0ffb9__"